module.exports = __webpack_public_path__ + "img/sixpackcarrier33.1e8b956e.jpg";